// ============================================================
// FIFA Nationality World Cup - 32 teams, every 4 years starting 2026
// 8 groups of 4 → Top 2 advance → Round of 16 → QF → SF → Final
// EWFL top performers called up based on nationality
// ============================================================
import { EMPTY_STATS, ROSTER_SIZE, LINEUP_SIZE, BENCH_SIZE, FORMATIONS, getPlayerStat, buildLineupForFormation } from './gameData';

// 32 national teams with star rosters (condensed - top ~8 stars + fill)
// Each team: name, flag, country, teamOvr, stars[]
export const WC_NATIONS_DATA = [
  { name: 'France', flag: '🇫🇷', country: 'France', teamOvr: 94, stars: [
    { name: 'Mike Maignan', position: 'GK', overall: 87, age: 30 },
    { name: 'Jules Koundé', position: 'RB', overall: 86, age: 27 },
    { name: 'William Saliba', position: 'CB', overall: 87, age: 24 },
    { name: 'Theo Hernández', position: 'LB', overall: 85, age: 28 },
    { name: 'Aurélien Tchouaméni', position: 'CDM', overall: 87, age: 25 },
    { name: 'Eduardo Camavinga', position: 'CM', overall: 84, age: 23 },
    { name: 'Antoine Griezmann', position: 'CAM', overall: 85, age: 34 },
    { name: 'Kylian Mbappé', position: 'ST', overall: 97, age: 27 },
    { name: 'Ousmane Dembélé', position: 'LW', overall: 86, age: 28 },
    { name: 'Bradley Barcola', position: 'RW', overall: 82, age: 23 }
  ]},
  { name: 'Brazil', flag: '🇧🇷', country: 'Brazil', teamOvr: 93, stars: [
    { name: 'Alisson Becker', position: 'GK', overall: 89, age: 33 },
    { name: 'Danilo', position: 'RB', overall: 82, age: 34 },
    { name: 'Marquinhos', position: 'CB', overall: 87, age: 31 },
    { name: 'Éder Militão', position: 'CB', overall: 86, age: 27 },
    { name: 'Casemiro', position: 'CDM', overall: 84, age: 33 },
    { name: 'Lucas Paquetá', position: 'CM', overall: 83, age: 28 },
    { name: 'Bruno Guimarães', position: 'CM', overall: 84, age: 28 },
    { name: 'Vinícius Júnior', position: 'LW', overall: 93, age: 25 },
    { name: 'Rodrygo', position: 'RW', overall: 88, age: 25 },
    { name: 'Raphinha', position: 'ST', overall: 86, age: 28 },
    { name: 'Neymar Jr', position: 'CAM', overall: 87, age: 33 }
  ]},
  { name: 'Argentina', flag: '🇦🇷', country: 'Argentina', teamOvr: 93, stars: [
    { name: 'Emiliano Martínez', position: 'GK', overall: 87, age: 33 },
    { name: 'Nahuel Molina', position: 'RB', overall: 82, age: 27 },
    { name: 'Cristian Romero', position: 'CB', overall: 85, age: 27 },
    { name: 'Nicolás Otamendi', position: 'CB', overall: 81, age: 37 },
    { name: 'Enzo Fernández', position: 'CM', overall: 84, age: 24 },
    { name: 'Alexis Mac Allister', position: 'CM', overall: 85, age: 27 },
    { name: 'Rodrigo De Paul', position: 'CDM', overall: 83, age: 31 },
    { name: 'Lionel Messi', position: 'CAM', overall: 89, age: 38 },
    { name: 'Julián Álvarez', position: 'ST', overall: 87, age: 25 },
    { name: 'Lautaro Martínez', position: 'ST', overall: 89, age: 28 }
  ]},
  { name: 'England', flag: '🏴󠁧󠁢󠁥󠁮󠁧󠁿', country: 'England', teamOvr: 92, stars: [
    { name: 'Jordan Pickford', position: 'GK', overall: 84, age: 31 },
    { name: 'Trent Alexander-Arnold', position: 'RB', overall: 87, age: 27 },
    { name: 'John Stones', position: 'CB', overall: 84, age: 31 },
    { name: 'Marc Guéhi', position: 'CB', overall: 82, age: 25 },
    { name: 'Luke Shaw', position: 'LB', overall: 83, age: 30 },
    { name: 'Declan Rice', position: 'CDM', overall: 87, age: 26 },
    { name: 'Jude Bellingham', position: 'CAM', overall: 92, age: 22 },
    { name: 'Bukayo Saka', position: 'RW', overall: 88, age: 24 },
    { name: 'Phil Foden', position: 'LW', overall: 89, age: 25 },
    { name: 'Harry Kane', position: 'ST', overall: 90, age: 32 }
  ]},
  { name: 'Spain', flag: '🇪🇸', country: 'Spain', teamOvr: 91, stars: [
    { name: 'Unai Simón', position: 'GK', overall: 84, age: 28 },
    { name: 'Dani Carvajal', position: 'RB', overall: 86, age: 33 },
    { name: 'Aymeric Laporte', position: 'CB', overall: 84, age: 31 },
    { name: 'Robin Le Normand', position: 'CB', overall: 82, age: 29 },
    { name: 'Rodri', position: 'CDM', overall: 92, age: 29 },
    { name: 'Pedri', position: 'CM', overall: 87, age: 23 },
    { name: 'Fabián Ruiz', position: 'CM', overall: 84, age: 29 },
    { name: 'Lamine Yamal', position: 'RW', overall: 88, age: 18 },
    { name: 'Nico Williams', position: 'LW', overall: 84, age: 23 },
    { name: 'Álvaro Morata', position: 'ST', overall: 82, age: 33 }
  ]},
  { name: 'Germany', flag: '🇩🇪', country: 'Germany', teamOvr: 91, stars: [
    { name: 'Marc-André ter Stegen', position: 'GK', overall: 87, age: 33 },
    { name: 'Joshua Kimmich', position: 'RB', overall: 89, age: 30 },
    { name: 'Antonio Rüdiger', position: 'CB', overall: 87, age: 32 },
    { name: 'Jonathan Tah', position: 'CB', overall: 84, age: 29 },
    { name: 'Toni Kroos', position: 'CM', overall: 85, age: 36 },
    { name: 'İlkay Gündoğan', position: 'CAM', overall: 83, age: 35 },
    { name: 'Jamal Musiala', position: 'CAM', overall: 89, age: 22 },
    { name: 'Florian Wirtz', position: 'LW', overall: 89, age: 22 },
    { name: 'Leroy Sané', position: 'RW', overall: 86, age: 29 },
    { name: 'Kai Havertz', position: 'ST', overall: 83, age: 26 }
  ]},
  { name: 'Portugal', flag: '🇵🇹', country: 'Portugal', teamOvr: 90, stars: [
    { name: 'Diogo Costa', position: 'GK', overall: 83, age: 26 },
    { name: 'João Cancelo', position: 'RB', overall: 85, age: 31 },
    { name: 'Rúben Dias', position: 'CB', overall: 89, age: 28 },
    { name: 'Pepe', position: 'CB', overall: 80, age: 42 },
    { name: 'Bruno Fernandes', position: 'CAM', overall: 87, age: 31 },
    { name: 'Bernardo Silva', position: 'CM', overall: 88, age: 31 },
    { name: 'Vitinha', position: 'CM', overall: 86, age: 25 },
    { name: 'Rafael Leão', position: 'LW', overall: 86, age: 26 },
    { name: 'Bernardo Silva', position: 'RW', overall: 88, age: 31 },
    { name: 'Cristiano Ronaldo', position: 'ST', overall: 88, age: 40 }
  ]},
  { name: 'Netherlands', flag: '🇳🇱', country: 'Netherlands', teamOvr: 89, stars: [
    { name: 'Bart Verbruggen', position: 'GK', overall: 81, age: 23 },
    { name: 'Denzel Dumfries', position: 'RB', overall: 82, age: 29 },
    { name: 'Virgil van Dijk', position: 'CB', overall: 89, age: 34 },
    { name: 'Nathan Aké', position: 'CB', overall: 82, age: 30 },
    { name: 'Frenkie de Jong', position: 'CM', overall: 85, age: 28 },
    { name: 'Cody Gakpo', position: 'LW', overall: 83, age: 26 },
    { name: 'Xavi Simons', position: 'CAM', overall: 83, age: 22 },
    { name: 'Memphis Depay', position: 'ST', overall: 82, age: 31 }
  ]},
  { name: 'Belgium', flag: '🇧🇪', country: 'Belgium', teamOvr: 88, stars: [
    { name: 'Thibaut Courtois', position: 'GK', overall: 90, age: 33 },
    { name: 'Kevin De Bruyne', position: 'CAM', overall: 88, age: 34 },
    { name: 'Romelu Lukaku', position: 'ST', overall: 83, age: 32 },
    { name: 'Jérémy Doku', position: 'LW', overall: 82, age: 23 }
  ]},
  { name: 'Italy', flag: '🇮🇹', country: 'Italy', teamOvr: 88, stars: [
    { name: 'Gianluigi Donnarumma', position: 'GK', overall: 89, age: 26 },
    { name: 'Alessandro Bastoni', position: 'CB', overall: 86, age: 26 },
    { name: 'Nicolò Barella', position: 'CM', overall: 87, age: 28 },
    { name: 'Federico Chiesa', position: 'RW', overall: 83, age: 28 }
  ]},
  { name: 'Croatia', flag: '🇭🇷', country: 'Croatia', teamOvr: 85, stars: [
    { name: 'Luka Modrić', position: 'CAM', overall: 86, age: 40 },
    { name: 'Mateo Kovačić', position: 'CM', overall: 83, age: 31 },
    { name: 'Joško Gvardiol', position: 'LB', overall: 86, age: 24 }
  ]},
  { name: 'Uruguay', flag: '🇺🇾', country: 'Uruguay', teamOvr: 85, stars: [
    { name: 'Federico Valverde', position: 'CM', overall: 89, age: 27 },
    { name: 'Darwin Núñez', position: 'ST', overall: 83, age: 26 }
  ]},
  { name: 'Morocco', flag: '🇲🇦', country: 'Morocco', teamOvr: 85, stars: [
    { name: 'Yassine Bounou', position: 'GK', overall: 84, age: 34 },
    { name: 'Achraf Hakimi', position: 'RB', overall: 86, age: 27 },
    { name: 'Hakim Ziyech', position: 'RW', overall: 81, age: 32 }
  ]},
  { name: 'Colombia', flag: '🇨🇴', country: 'Colombia', teamOvr: 84, stars: [
    { name: 'Luis Díaz', position: 'LW', overall: 85, age: 28 }
  ]},
  { name: 'Japan', flag: '🇯🇵', country: 'Japan', teamOvr: 83, stars: [
    { name: 'Zion Suzuki', position: 'GK', overall: 79, age: 23 },
    { name: 'Takehiro Tomiyasu', position: 'CB', overall: 82, age: 27 },
    { name: 'Ko Itakura', position: 'CB', overall: 80, age: 28 },
    { name: 'Wataru Endo', position: 'CDM', overall: 82, age: 32 },
    { name: 'Hidemasa Morita', position: 'CM', overall: 80, age: 30 },
    { name: 'Takefusa Kubo', position: 'RW', overall: 83, age: 24 },
    { name: 'Kaoru Mitoma', position: 'LW', overall: 84, age: 28 },
    { name: 'Takumi Minamino', position: 'CAM', overall: 80, age: 30 },
    { name: 'Daichi Kamada', position: 'CAM', overall: 80, age: 29 },
    { name: 'Ayase Ueda', position: 'ST', overall: 78, age: 27 }
  ]},
  { name: 'South Korea', flag: '🇰🇷', country: 'South Korea', teamOvr: 82, stars: [
    { name: 'Son Heung-min', position: 'LW', overall: 86, age: 33 },
    { name: 'Kim Min-jae', position: 'CB', overall: 84, age: 29 },
    { name: 'Lee Kang-in', position: 'CAM', overall: 80, age: 24 }
  ]},
  { name: 'Senegal', flag: '🇸🇳', country: 'Senegal', teamOvr: 83, stars: [
    { name: 'Édouard Mendy', position: 'GK', overall: 82, age: 33 },
    { name: 'Kalidou Koulibaly', position: 'CB', overall: 82, age: 34 },
    { name: 'Sadio Mané', position: 'LW', overall: 84, age: 33 }
  ]},
  { name: 'Switzerland', flag: '🇨🇭', country: 'Switzerland', teamOvr: 82, stars: [
    { name: 'Yann Sommer', position: 'GK', overall: 83, age: 37 },
    { name: 'Granit Xhaka', position: 'CM', overall: 84, age: 33 }
  ]},
  { name: 'Denmark', flag: '🇩🇰', country: 'Denmark', teamOvr: 82, stars: [
    { name: 'Kasper Schmeichel', position: 'GK', overall: 82, age: 39 },
    { name: 'Christian Eriksen', position: 'CAM', overall: 82, age: 34 }
  ]},
  { name: 'USA', flag: '🇺🇸', country: 'USA', teamOvr: 81, stars: [
    { name: 'Christian Pulisic', position: 'RW', overall: 83, age: 27 },
    { name: 'Weston McKennie', position: 'CM', overall: 80, age: 27 }
  ]},
  { name: 'Mexico', flag: '🇲🇽', country: 'Mexico', teamOvr: 81, stars: [
    { name: 'Guillermo Ochoa', position: 'GK', overall: 80, age: 40 },
    { name: 'Hirving Lozano', position: 'LW', overall: 80, age: 30 }
  ]},
  { name: 'Poland', flag: '🇵🇱', country: 'Poland', teamOvr: 81, stars: [
    { name: 'Wojciech Szczęsny', position: 'GK', overall: 84, age: 35 },
    { name: 'Robert Lewandowski', position: 'ST', overall: 88, age: 37 }
  ]},
  { name: 'Serbia', flag: '🇷🇸', country: 'Serbia', teamOvr: 81, stars: [
    { name: 'Dušan Vlahović', position: 'ST', overall: 84, age: 25 },
    { name: 'Sergej Milinković-Savić', position: 'CM', overall: 84, age: 30 }
  ]},
  { name: 'Ecuador', flag: '🇪🇨', country: 'Ecuador', teamOvr: 80, stars: [
    { name: 'Moisés Caicedo', position: 'CDM', overall: 84, age: 24 }
  ]},
  { name: 'Australia', flag: '🇦🇺', country: 'Australia', teamOvr: 78, stars: [] },
  { name: 'Iran', flag: '🇮🇷', country: 'Iran', teamOvr: 78, stars: [] },
  { name: 'Canada', flag: '🇨🇦', country: 'Canada', teamOvr: 79, stars: [
    { name: 'Alphonso Davies', position: 'LB', overall: 84, age: 25 }
  ]},
  { name: 'Saudi Arabia', flag: '🇸🇦', country: 'Saudi Arabia', teamOvr: 78, stars: [] },
  { name: 'Egypt', flag: '🇪🇬', country: 'Egypt', teamOvr: 80, stars: [
    { name: 'Mohamed Salah', position: 'RW', overall: 90, age: 33 }
  ]},
  { name: 'Nigeria', flag: '🇳🇬', country: 'Nigeria', teamOvr: 80, stars: [
    { name: 'Victor Osimhen', position: 'ST', overall: 87, age: 27 },
    { name: 'Ademola Lookman', position: 'LW', overall: 84, age: 28 }
  ]},
  { name: 'Ghana', flag: '🇬🇭', country: 'Ghana', teamOvr: 78, stars: [] },
  { name: 'Costa Rica', flag: '🇨🇷', country: 'Costa Rica', teamOvr: 77, stars: [] }
];

const FIRST_NAMES_BY_COUNTRY = {
  Japan: ['Shota','Yuto','Ren','Takumi','Haruki','Kenta','Riku','Hiroto','Sota','Daichi','Kaito','Ayumu','Takefusa','Junya','Wataru'],
  Brazil: ['Gabriel','Lucas','Pedro','Rafael','Bruno','Matheus','Vinicius','Richarlison','Rodrygo','Casemiro','Thiago','Joao','Diego','Eduardo'],
  Argentina: ['Lionel','Angel','Julian','Lautaro','Enzo','Rodrigo','Nicolas','Leandro','Emiliano','Cristian','Alejandro','Manuel','Thiago','Mateo'],
  France: ['Kylian','Antoine','Aurelien','Jules','Lucas','Hugo','Nathan','Eduardo','Theo','Ousmane','Raphael','Mathieu','Kingsley','Olivier','Benjamin'],
  England: ['Harry','Jude','Phil','Declan','Marcus','Trent','Bukayo','Jack','James','Oliver','Thomas','Jordan','John','Mason'],
  Germany: ['Joshua','Jamal','Leroy','Ilkay','Niclas','Kai','Leon','Serge','Florian','Benjamin','Pascal','Thomas','Manuel','Marc'],
  Spain: ['Alvaro','Rodrigo','Pedri','Gavi','Ferran','Unai','Mikel','Dani','Nico','Pablo','Sergio','Fernando','Marco','Alejandro'],
  Italy: ['Gianluigi','Federico','Nicolo','Sandro','Ciro','Leonardo','Marco','Alessandro','Matteo','Giovanni','Andrea','Lorenzo','Gianluca','Fabio'],
  Portugal: ['Cristiano','Bruno','Bernardo','Diogo','Ruben','Nuno','Joao','Rafael','Miguel','Vitinha','Goncalo','Fernando','Rui','Andre'],
  Netherlands: ['Virgil','Memphis','Frenkie','Denzel','Cody','Xavi','Nathan','Tijjani','Steven','Matthijs','Wout','Jurrien','Donny','Quincy'],
  Belgium: ['Kevin','Eden','Romelu','Thibaut','Jan','Axel','Yannick','Youri','Leandro','Dries','Timothy','Arthur','Michy','Amadou'],
  Croatia: ['Luka','Mateo','Mario','Marcelo','Ivan','Andrej','Nikola','Josip','Dejan','Domagoj','Borna','Josko','Petar','Lovro'],
  Uruguay: ['Luis','Edinson','Federico','Darwin','Nahitan','Rodrigo','Maxi','Giorgian','Matias','Diego','Facundo','Ronald','Jose','Sebastian'],
  Mexico: ['Hirving','Raul','Edson','Jesus','Luis','Jose','Carlos','Andres','Alexis','Cesar','Diego','Hector','Jorge','Orbelin','Miguel'],
  USA: ['Christian','Weston','Tyler','Gio','Brenden','Timothy','Yunus','Ricardo','Folarin','Matt','Antonee','Sergino','Walker','Mark','Tim'],
  Canada: ['Alphonso','Jonathan','Cyle','Tajon','Stephen','Richie','Jonathan','Kamal','Milan','Atiba','Scott','Derek','Junior','Liam'],
  SouthKorea: ['Son','Hwang','Lee','Kim','Park','Jung','Hong','Hwang','Cho','Choi','Yoon','Hwan','Jin','Woo','Dong'],
  Australia: ['Mathew','Aaron','Harry','Jackson','Mitchell','Riley','Connor','Craig','Martin','Trent','Ajdin','Jamie','Keanu','Awer','Daniel'],
  SaudiArabia: ['Salem','Mohammed','Salman','Khaled','Firas','Yasser','Ali','Saleh','Abdulelah','Saud','Sami','Hassan','Mohamad','Fahad','Abdulrahman'],
  Iran: ['Sardar','Mehdi','Alireza','Karim','Saman','Ali','Hossein','Vahid','Amir','Ehsan','Ramin','Omid','Milad','Saeid','Reza'],
  Qatar: ['Akram','Almoez','Hassan','Abdelkarim','Boualem','Karim','Ismail','Mohammed','Homam','Tarek','Abdulaziz','Ahmed','Khaled','Saad'],
  Morocco: ['Achraf','Hakim','Youssef','Sofyan','Romain','Azzedine','Ilias','Yahia','Noussair','Yassine','Amine','Abderrazak','Selim','Adam'],
  Senegal: ['Sadio','Kalidou','Edouard','Idrissa','Krepin','Nampalys','Abdou','Ismaila','Famara','Pape','Bamba','Boulaye','Habib','Youssouf'],
  Egypt: ['Mohamed','Mahmoud','Ahmed','Mostafa','Trezeguet','Hossam','Amr','Omar','Hamdi','Tarek','Marwan','Zizo','Mostafa','Emam'],
  Nigeria: ['Victor','Wilfred','Ahmed','Samuel','Kelechi','Alex','Moses','Joe','William','Calvin','Kenneth','Frank','Olisa','Raphael'],
  Ghana: ['Andre','Thomas','Mohammed','Jordan','Inaki','Tariq','Kudus','Kamal','Alexander','Osman','Daniel','Elisha','Baba','Abdul'],
  Switzerland: ['Granit','Xherdan','Breel','Remo','Yann','Manuel','Fabian','Silvan','Noah','Ricardo','Denis','Haris','Zeki','Nico'],
  Denmark: ['Christian','Kasper','Pierre','Simon','Andreas','Joachim','Pierre','Jannik','Mathias','Thomas','Victor','Rasmus','Mikkel','Andreas'],
  Poland: ['Robert','Piotr','Wojciech','Bartosz','Kamil','Matty','Karol','Arkadiusz','Jakub','Mateusz','Przemyslaw','Sebastian','Damian','Grzegorz'],
  Turkey: ['Burak','Hakan','Arda','Merih','Cengiz','Yusuf','Kerem','Ozan','Halil','Cihan','Caglar','Uğurcan','Orkun','Zeki'],
  Ecuador: ['Enner','Pervis','Moises','Piero','Angelo','Felix','Hernan','Alan','William','Xavier','Michael','Gonzalo','Alexander','Djorkaeff'],
  Colombia: ['James','Juan','Luis','Mateus','Radamel','Daniel','Wilmar','Yerry','David','Rafael','Jefferson','Camilo','Deiver','Juan'],
  Chile: ['Arturo','Alexis','Claudio','Gary','Charles','Eduardo','Erick','Alexander','Sebastian','Esteban','Guillermo','Marcelino','Ben','Cesar'],
  Peru: ['Paolo','Edison','Gianluca','Renato','Sergio','Christian','Luis','Andre','Yoshimar','Andy','Alex','Christofer','Marcos','Pedro'],
  Costa_Rica: ['Keylor','Celso','Bryan','Joel','Francisco','Anthony','Yeltsin','Carlos','Ronald','Daniel','Alvaro','Juan','Joseph','Kendall'],
  default: ['Alex','Sam','Chris','Jordan','Robin','Pat']
};
const LAST_NAMES_BY_COUNTRY = {
  Japan: ['Sato','Suzuki','Takahashi','Tanaka','Nakamura','Kimura','Ito','Watanabe','Yamamoto','Kobayashi','Saito','Mitoma','Kubo','Doan','Minamino'],
  Brazil: ['Silva','Santos','Oliveira','Souza','Costa','Ferreira','Pereira','Carvalho','Almeida','Lima','Ribeiro','Alves','Rocha','Martins','Araujo'],
  Argentina: ['Martinez','Rodriguez','Fernandez','Gonzalez','Lopez','Garcia','Perez','Diaz','Romero','Dybala','De Paul','Otamendi','Molina','Tagliafico'],
  France: ['Mbappe','Dembele','Griezmann','Tchouameni','Koundé','Hernandez','Kimpembe','Saliba','Thuram','Kolo Muani','Rabiot','Giroud','Varane','Pavard'],
  England: ['Kane','Bellingham','Foden','Rice','Rashford','Alexander-Arnold','Saka','Grealish','Stones','Walker','Maddison','Pickford','Bowen','Watkins'],
  Germany: ['Kimmich','Musiala','Sane','Gündoğan','Füllkrug','Havertz','Goretzka','Gnabry','Wirtz','Süle','Gross','Müller','Neuer','Can'],
  Spain: ['Morri','Hernandez','Pedri','Gavi','Torres','Simón','Merino','Olmo','Williams','Gavi','Busquets','Asensio','Verratti','Fornals'],
  Italy: ['Donnarumma','Chiesa','Barella','Tonali','Immobile','Bonucci','Verratti','Di Lorenzo','Politano','Frattesi','Pellegrini','Spinazzola','Cristante','Locatelli'],
  Portugal: ['Ronaldo','Fernandes','Silva','Jota','Dias','Mendes','Cancelo','Felix','Leao','Neves','Guerreiro','Costa','Patricio','Pepe'],
  Netherlands: ['van Dijk','Depay','de Jong','Dumfries','Gakpo','Simons','Ake','Reijnders','Bergwijn','de Ligt','Weghorst','Timber','Malen','Promes'],
  Belgium: ['De Bruyne','Hazard','Lukaku','Courtois','Vertonghen','Witsel','Carrasco','Tielemans','Trossard','Mertens','Castagne','Doku','Batshuayi','Onana'],
  Croatia: ['Modric','Kovacic','Mandzukic','Brozovic','Perisic','Kramaric','Vlasic','Majer','Gvardiol','Vida','Lovren','Petkovic','Sosa','Pasalic'],
  Uruguay: ['Suarez','Cavani','Valverde','Nunez','Nandez','Bentancur','Gomez','Araujo','Vecino','Godin','Rochet','Pellistri','Olivera','Ugarte'],
  Mexico: ['Lozano','Jimenez','Alvarez','Corona','Chavez','Macias','Herrera','Guardado','Vega','Antuna','Hernandez','Gutierrez','Medina','Montes','Sanchez'],
  USA: ['Pulisic','McKennie','Adams','Reyna','Aaronson','Weah','Musah','Pepi','Balogun','Turner','Robinson','Dest','Zimmerman','McKennie','Ferreira'],
  Canada: ['Davies','David','Larin','Buchanan','Eustaquio','Laryea','Osorio','Miller','Borjan','Hutchinson','Arfield','Cornelius','Cavallini','Millar'],
  SouthKorea: ['Heung-min','Hee-chan','Kang-in','Min-jae','Seong-jun','Woo-young','Hyun-woo','In-beom','Jin-su','Ji-soo','Sang-ho','Jun-ho','Chang-hoon','Ki-jin','Tae-seok'],
  Australia: ['Ryan','Mooy','Souttar','Irvine','Duke','McGree','Leckie','Goodwin','Boyle','Sainsbury','Hrustic','Maclaren','Mabil','Baccus','Arnold'],
  SaudiArabia: ['Al-Dawsari','Al-Breik','Al-Faraj','Al-Shehri','Al-Buraikan','Al-Malki','Al-Owais','Al-Najei','Al-Amri','Al-Ghannam','Al-Burayk','Al-Sulayhem','Al-Sahlawi','Al-Shahrani','Al-Khaibri'],
  Iran: ['Azmoun','Taremi','Jahanbakhsh','Ansarifard','Ghoddos','Karimi','Hosseini','Amiri','Mohammadi','Gholizadeh','Rezaeian','Ebrahimi','Abedzadeh','Beiranvand','Motahari'],
  Qatar: ['Afif','Ali','Al-Haydos','Hatem','Al-Moez','Boudiaf','Madibo','Mohammed','Abdulaziz','Barsham','Al-Rawi','Al-Sheeb','Abdullah','Muntari'],
  Morocco: ['Hakimi','Ziyech','En-Nesyri','Amrabat','Saïss','Ounahi','Boufal','Attiat-Allah','Mazraoui','Aguerd','Bono','Aboukhlal','Hamdallah','Cheddira'],
  Senegal: ['Mane','Koulibaly','Mendy','Gueye','Diatta','Dieng','Diallo','Sarr','Jakobs','Ciss','Jackson','Kouyate','Sabaly','Gomis'],
  Egypt: ['Salah','Hassan','Elneny','Trezeguet','Ashraf','Kahraba','Hamdi','Marmoush','Shoubair','Said','Hegazi','Zizo','Morsy','Abdel-Moneim'],
  Nigeria: ['Osimhen','Ndidi','Musa','Chukwueze','Iheanacho','Iwobi','Simon','Aribo','Troost-Ekong','Lookman','Onana','Ajayi','Awaziem','Sanusi'],
  Ghana: ['Ayew','Partey','Kudus','Salisu','Williams','Lamptey','Amartey','Bukari','Owusu','Baba','Odoi','Afena-Gyan','Atanga','Iddrisu'],
  Switzerland: ['Xhaka','Shaqiri','Embolo','Freuler','Sommer','Akanji','Schär','Widmer','Okafor','Rodriguez','Zakaria','Seferovic','Amdouni','Elvedi'],
  Denmark: ['Eriksen','Schmeichel','Højbjerg','Kjær','Christensen','Andersen','Olsen','Damsgaard','Maehle','Mæhle','Lindstrøm','Jensen','Nørgaard','Dolberg'],
  Poland: ['Lewandowski','Zielinski','Szczesny','Bednarek','Glik','Frankowski','Kash','Milik','Cash','Piatek','Kaminski','Wszolek','Swiderski','Grosicki'],
  Turkey: ['Yilmaz','Çalhanoğlu','Güler','Demiral','Ünder','Yazıcı','Müldür','Tekdemir','Akaydın','Kabak','Bardakcı','Kahveci','Söyüncü','Tüfekçi'],
  Ecuador: ['Valencia','Estupinan','Caicedo','Hincapie','Preciado','Torres','Galindez','Palacios','Pacho','Arreaga','Estrada','Mena','Arboleda','Reasco'],
  Colombia: ['Rodriguez','Cuadrado','Muriel','Uribe','Falcao','Barrios','Lerma','Mina','Ospina','Ruiz','Lerma','Santos','Arias','Machado'],
  Chile: ['Vidal','Sanchez','Bravo','Medel','Aranguiz','Aravena','Pulgar','Cortes','Vega','Valdes','Diaz','Luna','Brereton','Brereton'],
  Peru: ['Guerrero','Flores','Lapadula','Tapia','Peña','Cueva','Advincula','Carrillo','Yotun','Polo','Lora','Gonzales','Lopez','Quispe'],
  Costa_Rica: ['Navas','Borges','Ruiz','Campbell','Calvo','Contreras','Tejeda','Vargas','Matarrita','Chacón','Zamora','Pablo','Waston','Venegas'],
  default: ['Miller','Davis','Wilson','Anderson','Moore']
};
// Regional fallback pools — used when a specific country isn't explicitly listed.
// Lets all 190+ Nations tab teams have culturally fitting names.
const REGION_FIRST = {
  EuropeNorth:    ['Magnus','Erik','Lars','Henrik','Jonas','Anders','Olaf','Mikkel','Bjorn','Sander','Tobias','Kasper','Viktor','Lukas','Espen'],
  EuropeEast:     ['Andriy','Yuri','Pavel','Bogdan','Sergei','Ivan','Stefan','Marko','Lukas','Dmytro','Oleksandr','Vlad','Roman','Petar','Tomas'],
  EuropeSouth:    ['Marco','Luca','Stefano','Paolo','Andrea','Niko','Aleksandar','Goran','Stefanos','Dimitris','Yannis','Andreas','Vasilis','Petros','Mateo'],
  EuropeWest:     ['Mathieu','Quentin','Pierre','Hugo','Sebastian','Maximilian','Felix','Lukas','Jonas','Erik','Pieter','Lars','Sven','Henrik','Magnus'],
  AfricaWest:     ['Kwame','Kofi','Ibrahim','Mamadou','Cheikh','Boubacar','Moussa','Souleymane','Issa','Daouda','Ousmane','Modou','Abdoul','Diadie','Babacar'],
  AfricaEast:     ['Joshua','Brian','Daniel','Kevin','Samuel','Emmanuel','Stephen','Patrick','Michael','David','James','Joseph','Peter','John','Paul'],
  AfricaNorth:    ['Mohamed','Ahmed','Mahmoud','Karim','Hassan','Yassine','Anouar','Saber','Rachid','Tarek','Soufiane','Khalil','Brahim','Imad','Walid'],
  AfricaSouth:    ['Themba','Sipho','Lungelo','Nkosi','Bafana','Thabang','Kagiso','Lebo','Tshepo','Sibusiso','Mpho','Tumelo','Bongani','Karabo','Lwazi'],
  MiddleEast:     ['Yousef','Hassan','Hussein','Khaled','Omar','Sami','Faisal','Bassem','Tarek','Adel','Ziad','Saad','Walid','Nabil','Rami'],
  CentralAsia:    ['Bakhtiyor','Akmal','Sardor','Aziz','Ravshan','Otabek','Sanjar','Jakhongir','Eldar','Anvar','Iskandar','Asilbek','Doniyor','Ruslan','Davron'],
  SouthAsia:      ['Rahul','Sandesh','Anwar','Suresh','Sunil','Rohit','Vikram','Arjun','Imran','Rafiq','Bilal','Hassan','Asif','Karan','Sahil'],
  EastAsia:       ['Wei','Hao','Jun','Lei','Tao','Yang','Liu','Chen','Zhao','Sun','Jin','Min','Hyun','Jong','Tae'],
  SoutheastAsia:  ['Sok','Phan','Nguyen','Tran','Thanh','Khoa','Anh','Huy','Tuan','Bao','Hoang','Long','Linh','Dung','Vinh'],
  Oceania:        ['Roy','Toa','Sione','Manu','Tane','Sam','Henry','Eli','Ben','Jacob','Caleb','Will','Liam','Ryan','Jacob'],
  Caribbean:      ['Romario','Andre','Devon','Tristan','Kemar','Junior','Romario','Khalid','Kemoy','Damion','Trevon','Garey','Kerr','Sheldon','Jermaine'],
  LatinAmerica:   ['Diego','Carlos','Juan','Luis','Jose','Marco','Cristian','Alvaro','Pablo','Ricardo','Andres','Felipe','Mauricio','Jorge','Daniel'],
};
const REGION_LAST = {
  EuropeNorth:    ['Hansen','Olsen','Larsson','Andersen','Johansson','Eriksson','Nielsen','Lindqvist','Nordmann','Bjornsson','Magnussen','Solberg','Pettersson','Berg','Strand'],
  EuropeEast:     ['Ivanov','Kovalenko','Petrov','Nikolic','Popov','Stoyanov','Volkov','Kovalchuk','Horvat','Novak','Marković','Vukovic','Lukic','Petković','Hladik'],
  EuropeSouth:    ['Costa','Rossi','Bianchi','Romano','Russo','Greco','Papas','Stamatis','Karagiannis','Hadzi','Stanković','Stojanović','Vasilev','Demetriou','Pavlov'],
  EuropeWest:     ['Müller','Schmidt','Janssen','de Boer','Vermeulen','Becker','Weber','Schwarz','Hartmann','Lambert','Dubois','Lefebvre','van der Berg','Beck','Schneider'],
  AfricaWest:     ['Diallo','Diop','Sangare','Toure','Camara','Bah','Ndiaye','Conde','Doumbia','Cisse','Keita','Sissoko','Sow','Mendy','Sarr'],
  AfricaEast:     ['Omondi','Otieno','Wanyama','Mwangi','Kamau','Onyango','Kiprop','Cheruiyot','Okello','Ochieng','Hassan','Said','Juma','Mutua','Ndlovu'],
  AfricaNorth:    ['Ben Ali','El Sayed','Boukhari','Hassane','Bouchareb','Chetouane','Lahmar','Mansouri','Bouazizi','Trabelsi','Maaloul','El Amrani','Bouchnafa','Brahimi','El Hadj'],
  AfricaSouth:    ['Mthembu','Ndlovu','Khumalo','Zungu','Mokoena','Dlamini','Mahlangu','Mbatha','Nkambule','Sithole','Hlongwane','Tshabalala','Maluleka','Phiri','Banda'],
  MiddleEast:     ['Al-Saud','Al-Khalifa','Al-Mansoori','Al-Hashemi','Al-Husseini','Al-Rashidi','Al-Kuwari','Al-Yousef','Al-Otaibi','Al-Subaie','Al-Dosari','Al-Qahtani','Al-Sabah','Al-Mutairi','Al-Hamdan'],
  CentralAsia:    ['Karimov','Rustamov','Tursunov','Khamidov','Saidov','Akhmedov','Kurbanov','Yusupov','Rakhimov','Nazarov','Ergashev','Tashkenbaev','Babayev','Murodov','Aliyev'],
  SouthAsia:      ['Khan','Singh','Sharma','Patel','Kumar','Hassan','Rana','Ahmed','Roy','Das','Saha','Iqbal','Hossain','Ali','Mahmud'],
  EastAsia:       ['Wang','Li','Zhang','Liu','Chen','Yang','Huang','Lin','Park','Lee','Kim','Choi','Cho','Tanaka','Sato'],
  SoutheastAsia:  ['Sok','Nguyen','Tran','Le','Pham','Hoang','Ho','Phan','Cheng','Lim','Tan','Ong','Wong','Setiawan','Pratama'],
  Oceania:        ['Vea','Tupou','Latu','Fakatava','Tagaloa','Pouvalu','Wood','Tamatoa','Manaia','Whetu','Auva','Pita','Vunipola','Kepu','Maliepo'],
  Caribbean:      ['Williams','Brown','Clarke','Charles','Jacobs','Joseph','Martin','Simmons','Hyde','Lawrence','Sterling','Robinson','Lewis','Anderson','Daniel'],
  LatinAmerica:   ['Garcia','Lopez','Martinez','Hernandez','Gonzalez','Perez','Rodriguez','Sanchez','Ramirez','Torres','Flores','Rivera','Vargas','Castro','Mendoza'],
};

// Map every additional nation's country to a region for fallback name selection.
const COUNTRY_REGION = {
  // Europe
  Scotland: 'EuropeNorth', Wales: 'EuropeNorth', 'Northern Ireland': 'EuropeNorth', Ireland: 'EuropeNorth',
  Ukraine: 'EuropeEast', Sweden: 'EuropeNorth', Norway: 'EuropeNorth', Finland: 'EuropeNorth', Iceland: 'EuropeNorth',
  Austria: 'EuropeWest', Czechia: 'EuropeEast', Slovakia: 'EuropeEast', Hungary: 'EuropeEast',
  Romania: 'EuropeEast', Bulgaria: 'EuropeEast', Greece: 'EuropeSouth', Albania: 'EuropeSouth',
  Serbia: 'EuropeEast', Slovenia: 'EuropeEast', Bosnia: 'EuropeEast', 'N Macedonia': 'EuropeEast',
  Montenegro: 'EuropeEast', Kosovo: 'EuropeEast', Belarus: 'EuropeEast', Russia: 'EuropeEast',
  Moldova: 'EuropeEast', Estonia: 'EuropeNorth', Latvia: 'EuropeNorth', Lithuania: 'EuropeNorth',
  Luxembourg: 'EuropeWest', Malta: 'EuropeSouth', Cyprus: 'EuropeSouth', Andorra: 'EuropeWest',
  'San Marino': 'EuropeSouth', Liechtenstein: 'EuropeWest', Gibraltar: 'EuropeSouth', 'Faroe Islands': 'EuropeNorth',
  Armenia: 'EuropeEast', Azerbaijan: 'CentralAsia', Georgia: 'EuropeEast', Israel: 'MiddleEast',
  Kazakhstan: 'CentralAsia',
  // South America
  Chile: 'LatinAmerica', Paraguay: 'LatinAmerica', Bolivia: 'LatinAmerica', Venezuela: 'LatinAmerica',
  // CONCACAF
  Canada: 'EuropeWest', 'Costa Rica': 'LatinAmerica', Panama: 'LatinAmerica', Honduras: 'LatinAmerica',
  Guatemala: 'LatinAmerica', 'El Salvador': 'LatinAmerica', Nicaragua: 'LatinAmerica', Belize: 'Caribbean',
  Jamaica: 'Caribbean', Cuba: 'Caribbean', Haiti: 'Caribbean', 'Dominican Rep': 'Caribbean',
  Trinidad: 'Caribbean', Curacao: 'Caribbean', Suriname: 'Caribbean', Guyana: 'Caribbean',
  Barbados: 'Caribbean', Bahamas: 'Caribbean', Bermuda: 'Caribbean', Grenada: 'Caribbean',
  'St Lucia': 'Caribbean', 'St Kitts': 'Caribbean', Antigua: 'Caribbean', Dominica: 'Caribbean',
  Cayman: 'Caribbean', 'Puerto Rico': 'Caribbean',
  // Africa
  Algeria: 'AfricaNorth', Tunisia: 'AfricaNorth', Libya: 'AfricaNorth', Cameroon: 'AfricaWest',
  'Ivory Coast': 'AfricaWest', Mali: 'AfricaWest', 'Burkina Faso': 'AfricaWest', Guinea: 'AfricaWest',
  'Guinea-Bissau': 'AfricaWest', 'Sierra Leone': 'AfricaWest', Liberia: 'AfricaWest', 'Cape Verde': 'AfricaWest',
  Gambia: 'AfricaWest', Mauritania: 'AfricaWest', 'Senegal B': 'AfricaWest', Togo: 'AfricaWest', Benin: 'AfricaWest',
  Niger: 'AfricaWest', Chad: 'AfricaWest', CAR: 'AfricaWest', 'Eq Guinea': 'AfricaWest', Gabon: 'AfricaWest',
  Congo: 'AfricaWest', 'DR Congo': 'AfricaWest', Angola: 'AfricaWest',
  Zambia: 'AfricaEast', Zimbabwe: 'AfricaEast', Malawi: 'AfricaEast', Mozambique: 'AfricaEast',
  Botswana: 'AfricaSouth', Namibia: 'AfricaSouth', Lesotho: 'AfricaSouth', Eswatini: 'AfricaSouth',
  'South Africa': 'AfricaSouth', Madagascar: 'AfricaEast', Mauritius: 'AfricaEast', Seychelles: 'AfricaEast',
  Comoros: 'AfricaEast', Sudan: 'AfricaNorth', 'South Sudan': 'AfricaEast', Ethiopia: 'AfricaEast',
  Eritrea: 'AfricaEast', Djibouti: 'AfricaEast', Somalia: 'AfricaEast', Kenya: 'AfricaEast',
  Uganda: 'AfricaEast', Tanzania: 'AfricaEast', Rwanda: 'AfricaEast', Burundi: 'AfricaEast',
  'Sao Tome': 'AfricaWest',
  // Asia
  'South Korea': 'EastAsia',
  Iraq: 'MiddleEast', UAE: 'MiddleEast', Bahrain: 'MiddleEast', Oman: 'MiddleEast', Kuwait: 'MiddleEast',
  Yemen: 'MiddleEast', Jordan: 'MiddleEast', Lebanon: 'MiddleEast', Syria: 'MiddleEast', Palestine: 'MiddleEast',
  Afghanistan: 'CentralAsia', Pakistan: 'SouthAsia', India: 'SouthAsia', Bangladesh: 'SouthAsia',
  Nepal: 'SouthAsia', Bhutan: 'SouthAsia', 'Sri Lanka': 'SouthAsia', Maldives: 'SouthAsia',
  Myanmar: 'SoutheastAsia', Thailand: 'SoutheastAsia', Vietnam: 'SoutheastAsia', Cambodia: 'SoutheastAsia',
  Laos: 'SoutheastAsia', Malaysia: 'SoutheastAsia', Singapore: 'SoutheastAsia', Indonesia: 'SoutheastAsia',
  Philippines: 'SoutheastAsia', Brunei: 'SoutheastAsia', 'Timor-Leste': 'SoutheastAsia',
  China: 'EastAsia', 'Hong Kong': 'EastAsia', Macau: 'EastAsia', 'Chinese Taipei': 'EastAsia',
  Mongolia: 'EastAsia', 'North Korea': 'EastAsia',
  Kyrgyzstan: 'CentralAsia', Tajikistan: 'CentralAsia', Turkmenistan: 'CentralAsia', Uzbekistan: 'CentralAsia',
  // Oceania
  'New Zealand': 'Oceania', Fiji: 'Oceania', PNG: 'Oceania', 'Solomon Is': 'Oceania',
  'New Caledonia': 'Oceania', Tahiti: 'Oceania', Vanuatu: 'Oceania', Samoa: 'Oceania',
  'American Samoa': 'Oceania', Tonga: 'Oceania', 'Cook Islands': 'Oceania',
};

const genName = (country) => {
  const key = (country || '').replace(/\s+/g, '');
  const explicitFirst = FIRST_NAMES_BY_COUNTRY[key] || FIRST_NAMES_BY_COUNTRY[country];
  const explicitLast  = LAST_NAMES_BY_COUNTRY[key]  || LAST_NAMES_BY_COUNTRY[country];
  // If we have explicit pools, use them. Otherwise fall back to region pool.
  const region = COUNTRY_REGION[country] || COUNTRY_REGION[key];
  const regionFirst = region ? REGION_FIRST[region] : null;
  const regionLast  = region ? REGION_LAST[region]  : null;
  const f = explicitFirst || regionFirst || FIRST_NAMES_BY_COUNTRY.default;
  const l = explicitLast  || regionLast  || LAST_NAMES_BY_COUNTRY.default;
  return `${f[Math.floor(Math.random() * f.length)]} ${l[Math.floor(Math.random() * l.length)]}`;
};

const ROSTER_POSITIONS = [
  'GK','GK','GK',
  'CB','CB','CB','LB','LB','RB','RB',
  'CDM','CDM','CM','CM','CM','CAM','LM','RM',
  'LW','LW','RW','RW','ST','ST','CF'
];

/**
 * Build a national team with stars + filler players and (optionally) EWFL call-ups.
 * callups: array of ewfl players who play for this nation; they REPLACE equivalent-position filler players.
 */
export const buildNationalTeam = (def, callups = []) => {
  const teamId = `wc-${def.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`;
  const players = [];
  let number = 1;
  // Stars first — but per user request, randomize ALL names (no hardcoded stars)
  (def.stars || []).forEach(s => {
    players.push({
      id: `${teamId}-s-${number}`,
      number,
      name: genName(def.country),
      position: s.position,
      overall: s.overall,
      age: s.age,
      nationality: def.country,
      flag: def.flag,
      potential: Math.min(99, s.overall + (s.age < 25 ? 5 : 1)),
      seasonStartOverall: s.overall,
      stats: EMPTY_STATS(),
      isRookie: s.age <= 19,
      fromClub: 'National Star'
    });
    number++;
  });
  // EWFL Call-ups (tag them)
  callups.forEach(cu => {
    players.push({
      ...cu,
      id: `${teamId}-cu-${number}`,
      number,
      nationality: def.country,
      flag: def.flag,
      stats: EMPTY_STATS(), // fresh WC stats
      fromClub: cu.fromClub || 'EWFL',
      ewflCallup: true,
      ewflOriginId: cu.id
    });
    number++;
  });
  // Filler
  while (players.length < ROSTER_SIZE) {
    const pos = ROSTER_POSITIONS[players.length] || 'CM';
    const ageMin = pos === 'GK' ? 22 : 19;
    const age = Math.floor(Math.random() * 14) + ageMin;
    const overall = Math.max(60, Math.min(92, def.teamOvr - 10 + Math.floor(Math.random() * 9)));
    players.push({
      id: `${teamId}-f-${number}`,
      number,
      name: genName(def.country),
      position: pos,
      overall, age,
      nationality: def.country,
      flag: def.flag,
      potential: Math.min(99, overall + 3),
      seasonStartOverall: overall,
      stats: EMPTY_STATS(),
      isRookie: age <= 19,
      fromClub: 'Domestic League'
    });
    number++;
  }
  const finalPlayers = players.slice(0, ROSTER_SIZE).sort((a, b) => b.overall - a.overall).map((p, i) => ({ ...p, number: i + 1 }));
  const base = {
    id: teamId,
    name: def.name,
    country: def.country,
    flag: def.flag,
    teamOvr: def.teamOvr,
    formation: def.formation || FORMATIONS[0].name,
    players: finalPlayers,
    stats: { played: 0, won: 0, drawn: 0, lost: 0, goalsFor: 0, goalsAgainst: 0, points: 0 }
  };
  const { lineup, bench } = buildLineupForFormation(base);
  return { ...base, lineup, bench };
};

/**
 * Pick top EWFL performers by nationality, to be called up to their national team.
 * Criteria: MVP score (goals*3 + assists*2 + cleanSheets*2 - yellows*0.5 - reds*2). Top 3 per nation max.
 */
export const selectEWFLCallups = (ewflTeams, nationCountry) => {
  const pool = ewflTeams.flatMap(t => t.players.filter(p => p.nationality === nationCountry).map(p => ({ ...p, fromClub: t.name })));
  const scored = pool.map(p => {
    const score = getPlayerStat(p, 'goals') * 3 + getPlayerStat(p, 'assists') * 2 + getPlayerStat(p, 'cleanSheets') * 2 - getPlayerStat(p, 'yellowCards') * 0.5 - getPlayerStat(p, 'redCards') * 2;
    return { ...p, callupScore: score };
  });
  // Prioritize high overall + positive MVP score
  scored.sort((a, b) => (b.callupScore + b.overall * 0.1) - (a.callupScore + a.overall * 0.1));
  return scored.slice(0, 3);
};

/**
 * Build all 32 national teams for the World Cup, pulling EWFL callups for each nationality.
 */
export const buildWorldCupTeams = (ewflTeams) => {
  return WC_NATIONS_DATA.map(def => {
    const callups = selectEWFLCallups(ewflTeams, def.country);
    return buildNationalTeam(def, callups);
  });
};

/**
 * Build EVERY national team — the 32 WC nations plus the 190 others (~220 total).
 * If `preBuiltWcTeams` is supplied, those exact team objects are reused for the
 * 32 World-Cup nations so the WC tab and Nations tab show the IDENTICAL roster
 * (no re-randomised names, no second instance).
 */
import { OTHER_NATIONS_DATA } from './otherNations';
export const buildAllNationalTeams = (ewflTeams = [], preBuiltWcTeams = null) => {
  const wc = (preBuiltWcTeams && preBuiltWcTeams.length === WC_NATIONS_DATA.length)
    ? preBuiltWcTeams
    : WC_NATIONS_DATA.map(def => buildNationalTeam(def, selectEWFLCallups(ewflTeams, def.country)));
  const others = OTHER_NATIONS_DATA.map(def => buildNationalTeam(def, []));
  return [...wc, ...others];
};
export const buildOtherNationalTeams = () =>
  OTHER_NATIONS_DATA.map(def => buildNationalTeam(def, []));

/**
 * Draw 8 groups of 4 teams. Seeds top 8 into pot 1, next 8 pot 2, etc.
 */
export const drawGroupsOfFour = (teams) => {
  const sorted = [...teams].sort((a, b) => b.teamOvr - a.teamOvr);
  const pot1 = sorted.slice(0, 8);
  const pot2 = sorted.slice(8, 16);
  const pot3 = sorted.slice(16, 24);
  const pot4 = sorted.slice(24, 32);
  [pot2, pot3, pot4].forEach(p => p.sort(() => Math.random() - 0.5));
  const groups = [];
  for (let i = 0; i < 8; i++) {
    groups.push({
      name: String.fromCharCode(65 + i),
      teamIds: [pot1[i].id, pot2[i].id, pot3[i].id, pot4[i].id],
      fixtures: [],
      standings: {},
      completed: false
    });
  }
  // Initialize standings + fixtures
  groups.forEach(g => {
    g.teamIds.forEach(id => { g.standings[id] = { played: 0, won: 0, drawn: 0, lost: 0, gf: 0, ga: 0, points: 0 }; });
    const ids = g.teamIds;
    for (let i = 0; i < ids.length; i++) {
      for (let j = i + 1; j < ids.length; j++) {
        g.fixtures.push({ id: `${g.name}-${i}-${j}`, homeId: ids[i], awayId: ids[j], homeScore: null, awayScore: null, played: false, events: null, matchRatings: null });
      }
    }
  });
  return groups;
};

export const isWCYear = (year) => year >= 2026 && (year - 2026) % 4 === 0;
export const nextWCYear = (year) => {
  let y = 2026;
  while (y < year) y += 4;
  return y;
};
